import * as Yup from 'yup'

export const ManualReachbirdCollaborationSchema = Yup.object().shape({
  campaign_name: Yup.string().trim().required('This field is required.').max(255, 'Name is too long.'),
  brand: Yup.string().trim().max(255, 'Brand is too long.'),
  start_date: Yup.string(),
  end_date: Yup.string().test('after-start', 'End date must be on or after the start date.', function (value) {
    const { start_date } = this.parent
    return !value || !start_date || value >= start_date
  }),
  providers: Yup.array().of(Yup.string()),
  payout_amount: Yup.number()
    .transform((value, original) => {
      const text = String(original ?? '').trim()
      if (text === '') return null
      return Number(text.replace(',', '.'))
    })
    .typeError('Enter a number.')
    .min(0, 'Payout cannot be negative.')
    .nullable(),
  currency: Yup.string().required('This field is required.'),
  notes: Yup.string()
});
